import React, { Dispatch, SetStateAction } from "react";
import { RaceProgram, RaceVideoFeedback } from "@tvg/ts-types/Race";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { Status } from "../../../types";
import MobileHeader from "./MobileHeader";
import Header from "./DesktopHeader";
import { isFdr } from "../../../utils/general";

interface HeaderWrapperProps {
  mtp: number;
  status: Status;
  postTime: string;
  setIsMtpHidden: Dispatch<SetStateAction<boolean>>;
  isMobile: boolean;
  isLogged?: boolean;
  balance: number;
  race: RaceProgram;
  prevPath?: string;
  openLogin?: NullaryFn<void>;
  openRegister?: NullaryFn<void>;
  onAccBalanceClick?: NullaryFn<void>;
  title: string;
  onClickVideo: NullaryFn<void>;
  onClickFavorite: NullaryFn<void>;
  videoFeedback?: RaceVideoFeedback;
  withVideo?: boolean;
}

const HeaderWrapper = ({
  mtp = 0,
  status,
  postTime,
  setIsMtpHidden,
  isMobile,
  isLogged,
  balance,
  race,
  prevPath,
  openLogin,
  openRegister,
  onAccBalanceClick,
  title,
  onClickVideo,
  onClickFavorite,
  videoFeedback,
  withVideo
}: HeaderWrapperProps) => {
  if (isMobile) {
    return (
      <MobileHeader
        prevPath={prevPath}
        race={race}
        balance={balance}
        isLogged={!!isLogged}
        onAccBalanceClick={onAccBalanceClick}
        openLogin={openLogin}
        openRegister={openRegister}
        mtp={+mtp}
        status={status}
        postTime={postTime}
        title={title}
        onClickVideo={onClickVideo}
        onClickFavorite={onClickFavorite}
        videoFeedback={videoFeedback}
        withVideo={withVideo}
      />
    );
  }

  if ((!withVideo && isFdr()) || !isFdr()) {
    return (
      <Header
        mtp={+mtp}
        status={status}
        postTime={postTime as string}
        setIsMtpHidden={setIsMtpHidden}
      />
    );
  }

  return null;
};

export default HeaderWrapper;
